<template>
<div class="infopoints_view">
<b-container fluid>
    <b-row>
        <b-col cols="8">
            <card>
                <SseDisplayTable 
                    @selectItem="onSelectItem"
                    @newItem="onNewItem"
                    :item="item ? item.id : null">
                </SseDisplayTable>
            </card>
        </b-col>
        <b-col cols="4">
            <InfoCard v-if="action == ''"></InfoCard>

            <card v-if="action == 'new'">
                <CardHeader :title="$t('item.new')"/>
                <SseDisplayEditor :item="item" action="new" @itemSaved="onSelectItem"/>
            </card>

            <card v-if="action == 'item' && item">
                <CardHeader :title="item ? item.uniqueId : ''" type="item" />
                <tabs>
                    <tab-pane title="tab-1" key="tab-1" v-if="$UIPrivilege('devices/ssedisplays', 'screenshot')">
                        <b-icon id="screenshot-icon" slot="title" icon="aspect-ratio" scale="1.1"></b-icon>
                        <b-popover target="screenshot-icon" triggers="hover" placement="top">
                        {{$t("sse_displays.tooltips.screenshot")}}
                         </b-popover>
                        <SseDisplayScreenshot :item="item" refreshBtn="true" />
                        <ScreenshotHistory :item="item" />
                    </tab-pane>
                    <tab-pane title="tab-2" key="tab-2" v-if="$UIPrivilege('devices/ssedisplays', 'actions')">
                        <b-icon id="actions-icon" slot="title" icon="arrow-left-right" scale='1.1'></b-icon> 
                        <b-popover target="actions-icon" triggers="hover" placement="top">
                        {{$t("sse_displays.tooltips.actions")}}
                         </b-popover>
                        <SseDisplayActions :item="item" />
                    </tab-pane>
                    <tab-pane  title="tab-3" key="tab-3" v-if="$UIPrivilege('devices/ssedisplays', 'status')">
                         <b-icon id ="status-icon" slot="title" icon="bar-chart" scale="1.1"></b-icon>
                         <b-popover target="status-icon" triggers="hover" placement="top">
                         {{$t("sse_displays.tooltips.status")}}
                        </b-popover>
                        <SseDisplayStatus :display='item'/>
                    </tab-pane>
                    <tab-pane  title="tab-4" key="tab-4" v-if="$UIPrivilege('devices/ssedisplays', 'layout')">
                        <b-icon id="layout-icon" slot="title" icon="columns" scale="1.1"></b-icon>
                        <b-popover target="layout-icon" triggers="hover" placement="top">
                            {{$t("sse_displays.tooltips.layout")}}
                        </b-popover>
                        <SseDisplayLayouts :item="item" />
                    </tab-pane>
                     <tab-pane  title="tab-5" key="tab-5" v-if="$UIPrivilege('devices/ssedisplays', 'settings')">
                        <b-icon id="settings-icon" slot="title" icon="card-list" scale="1.1"></b-icon>
                        <b-popover target="settings-icon" triggers="hover" placement="top">
                            {{$t("sse_displays.tooltips.settings")}}
                        </b-popover>
                        <SseDisplayEditor :item="item" action="edit" />
                    </tab-pane>
                    <tab-pane  title="tab-6" key="tab-6" v-if="$UIPrivilege('devices/ssedisplays', 'sse.logs')">
                        <b-icon id="logs-icon" slot="title" icon="card-text" scale="1.1"></b-icon>
                         <b-popover target="logs-icon" triggers="hover" placement="top">
                            {{$t("sse_displays.tooltips.logs")}}
                        </b-popover>
                        <SseDisplayLogs :item="item"/>
                    </tab-pane>
                </tabs>
            </card>   
 
        </b-col>
    </b-row>
</b-container>
</div>
</template>
<script>

import SseDisplayTable from '@/components/Devices/SseDisplays/SseDisplayTable'
import SseDisplayScreenshot from '@/components/Devices/SseDisplays/SseDisplayScreenshot'
import SseDisplayStatus from '@/components/Devices/SseDisplays/SseDisplayStatus'
import SseDisplayEditor from '@/components/Devices/SseDisplays/SseDisplayEditor'
import SseDisplayLayouts from '@/components/Devices/SseDisplays/SseDisplayLayouts'
import SseDisplayActions from '@/components/Devices/SseDisplays/SseDisplayActions'
import SseDisplayLogs from '@/components/Devices/SseDisplays/SseDisplayLogs'
import ScreenshotHistory from '@/components/Devices/ScreenshotHistory'


export default {
    name: 'SseDisplays',
    components: {
        SseDisplayTable,
        SseDisplayScreenshot,
        SseDisplayStatus,
        SseDisplayEditor,
        SseDisplayLayouts,
        SseDisplayActions,
        SseDisplayLogs,
        ScreenshotHistory
    },
    data: function() {
        return {
            action: "",
            item: {}
        }
    },
    watch: {
        item() {
            //if(!this.item) this.action = "";
        } 
    },
    methods: {
        onNewItem() {
            this.item = null;
            this.action = "new"
        },
        onSelectItem(item) {
            this.item = item;
            this.action = "item"
        }
    }
}
</script>
